// Os dados da conta em tela: código, quem abriu, tempo aberto, taxas,
// desconto e — no delivery — os últimos pedidos do cliente.
import React from "react";
import { DadosDoPedido } from "../../../../store/Slices/orderSlice";
import * as Styles from "../../styles/PointOfSale.styles";
import {
  formatDateTime,
  formatTime,
  getTimeDifference,
} from "../../../../dominio/dataEHora";
import { infosDoTipo } from "../../../../dominio/conta.tipos";
import {
  baseDoDesconto,
  descontoDaConta,
  descontoDosProdutos,
  taxasDaConta,
  totalDeTaxas,
  totalDosProdutos,
} from "../../../../dominio/totaisDaConta";

export const RotuloDaConta: React.FC<{
  component: any;
  componentProps: any;
  orderDataZustand: DadosDoPedido;
  subsidiaryDataZustand: any;
  lastOrderSelected: any;
  handleLastOrdersRowClick: (order: any) => void;
  handleRemoveLastOrder: () => void;
  addProductFromLastOrder: (lastProduct: any) => void;
  addProductObservationFromLastOrder: (obs: any) => void;
}> = ({
  component,
  componentProps,
  orderDataZustand,
  subsidiaryDataZustand,
  lastOrderSelected,
  handleLastOrdersRowClick,
  handleRemoveLastOrder,
  addProductFromLastOrder,
  addProductObservationFromLastOrder,
}) => {
  if (orderDataZustand.orderType === "1") {
    return (
      <Styles.OrderInfoContainer
        selected={Boolean(component.componentSelected)}
        id={String(component.componentId)}
        componentPosition={componentProps.componentPosition}
        componentBrightness={String(componentProps.componentBrightness)}
        componentWidth={String(componentProps.componentWidth)}
        componentHeight={String(componentProps.componentHeight)}
        componentStatus={String(componentProps.componentStatus)}
        componentColor={String(componentProps.componentColor)}
      >
        {component.componentSelected && (
          <Styles.SelectedIcon
            top={component.componentProps.componentPosition.y}
            left={component.componentProps.componentPosition.x}
          >
            zoom_out_map
          </Styles.SelectedIcon>
        )}
        {orderDataZustand ? (
          <>
            <Styles.OrderInfoLabel infoAlign="left">
              Número da Conta:
            </Styles.OrderInfoLabel>
            <Styles.OrderInfoLabel infoAlign="left">
              {orderDataZustand.orderCode}
            </Styles.OrderInfoLabel>
            <Styles.OrderInfoLabel infoAlign="left">
              Atendida por:
            </Styles.OrderInfoLabel>
            <Styles.OrderInfoLabel infoAlign="left">
              {orderDataZustand.orderOwnerName}
            </Styles.OrderInfoLabel>
            <Styles.OrderInfoLabel infoAlign="left">
              Tipo de Conta:
            </Styles.OrderInfoLabel>
            <Styles.OrderInfoLabel infoAlign="left">
              {Number(orderDataZustand.orderType) === 1
                ? "Atendimento na Mesa"
                : Number(orderDataZustand.orderType) === 2
                  ? "Balcão"
                  : Number(orderDataZustand.orderType) === 3
                    ? "Delivery"
                    : ""}
            </Styles.OrderInfoLabel>
            <Styles.OrderInfoLabel infoAlign="left">
              Tempo Decorrido:
            </Styles.OrderInfoLabel>
            <Styles.OrderInfoLabel infoAlign="left">
              {orderDataZustand.createdAt ? (
                <>
                  {formatTime(
                    new Date(orderDataZustand.createdAt)
                  )}
                </>
              ) : null}
            </Styles.OrderInfoLabel>
            <Styles.OrderInfoLabel infoAlign="left">
              Total de Produtos:
            </Styles.OrderInfoLabel>
            <Styles.OrderInfoLabel infoAlign="left">
              {orderDataZustand.products
                ? orderDataZustand.products.reduce(
                  (total, product) => total,
                  0
                )
                : 0}
            </Styles.OrderInfoLabel>
          </>
        ) : null}
      </Styles.OrderInfoContainer>
    );
  }
  else if (orderDataZustand.orderType === "2") {
    return (
      <Styles.OrderInfoContainer
        selected={Boolean(component.componentSelected)}
        id={String(component.componentId)}
        componentPosition={componentProps.componentPosition}
        componentBrightness={String(componentProps.componentBrightness)}
        componentWidth={String(componentProps.componentWidth)}
        componentHeight={String(componentProps.componentHeight)}
        componentStatus={String(componentProps.componentStatus)}
        componentColor={String(componentProps.componentColor)}
      >
        {component.componentSelected && (
          <Styles.SelectedIcon
            top={component.componentProps.componentPosition.y}
            left={component.componentProps.componentPosition.x}
          >
            zoom_out_map
          </Styles.SelectedIcon>
        )}
        {orderDataZustand ? (
          <>
            <Styles.OrderInfoLabel infoAlign="left">
              Número da Conta:
            </Styles.OrderInfoLabel>
            <Styles.OrderInfoLabel infoAlign="left">
              {orderDataZustand.orderCode}
            </Styles.OrderInfoLabel>
            <Styles.OrderInfoLabel infoAlign="left">
              Atendida por:
            </Styles.OrderInfoLabel>
            <Styles.OrderInfoLabel infoAlign="left">
              {orderDataZustand.orderOwnerName}
            </Styles.OrderInfoLabel>
            <Styles.OrderInfoLabel infoAlign="left">
              Tipo de Conta:
            </Styles.OrderInfoLabel>
            <Styles.OrderInfoLabel infoAlign="left">
              {Number(orderDataZustand.orderType) === 1
                ? "Atendimento na Mesa"
                : Number(orderDataZustand.orderType) === 2
                  ? "Balcão"
                  : Number(orderDataZustand.orderType) === 3
                    ? "Delivery"
                    : ""}
            </Styles.OrderInfoLabel>
            <Styles.OrderInfoLabel infoAlign="left">
              Tempo Decorrido:
            </Styles.OrderInfoLabel>
            <Styles.OrderInfoLabel infoAlign="left">
              {orderDataZustand.createdAt ? (
                <>
                  {getTimeDifference(
                    new Date(orderDataZustand.createdAt)
                  )}
                </>
              ) : null}
            </Styles.OrderInfoLabel>
            <Styles.OrderInfoLabel infoAlign="left">
              Total de Produtos:
            </Styles.OrderInfoLabel>
            <Styles.OrderInfoLabel infoAlign="left">
              {orderDataZustand.products
                ? orderDataZustand.products.reduce(
                  (total, product) => total,
                  0
                )
                : 0}
            </Styles.OrderInfoLabel>
          </>
        ) : null}
      </Styles.OrderInfoContainer>
    );
  }
  else if (orderDataZustand.orderType === "3") {
    let lastOrdersExist = false;
    //retornar as contas do cliente que foram concluídas.
    const currentCustomerOrders = subsidiaryDataZustand?.selectedPdv?.selectedPeriod?.periodInfo?.periodOrders?.filter((order: any) => {
      const customerAddressOrderInfo = order.orderInfo.find((info: any) => info.orderInfoName === "CustomerAddress");

      if (customerAddressOrderInfo && JSON.parse(customerAddressOrderInfo.orderInfoValue).customerUuid === orderDataZustand.orderInfo.customerUuid && order.orderStatus === 6) {
        lastOrdersExist = true;
        return true;
      }

      return false;
    });

    return (
      <Styles.OrderInfoDeliveryContainer
        selected={Boolean(component.componentSelected)}
        id={String(component.componentId)}
        componentPosition={componentProps.componentPosition}
        componentBrightness={String(componentProps.componentBrightness)}
        componentWidth={String(componentProps.componentWidth)}
        componentHeight={String(componentProps.componentHeight)}
        componentStatus={String(componentProps.componentStatus)}
        componentColor={String(componentProps.componentColor)}
      >
        {component.componentSelected && (
          <Styles.SelectedIcon
            top={component.componentProps.componentPosition.y}
            left={component.componentProps.componentPosition.x}
          >
            zoom_out_map
          </Styles.SelectedIcon>
        )}
        {orderDataZustand ? (
          <>
            <Styles.OrderInfoDeliveryLabel infoAlign="left">
              Número da Conta:
            </Styles.OrderInfoDeliveryLabel>
            <Styles.OrderInfoDeliveryLabel infoAlign="left">
              {orderDataZustand.orderCode}
            </Styles.OrderInfoDeliveryLabel>
            <Styles.OrderInfoDeliveryLabel infoAlign="left">
              Atendida por:
            </Styles.OrderInfoDeliveryLabel>
            <Styles.OrderInfoDeliveryLabel infoAlign="left">
              {orderDataZustand.orderOwnerName}
            </Styles.OrderInfoDeliveryLabel>
            <Styles.OrderInfoDeliveryLabel infoAlign="left">
              Tipo de Conta:
            </Styles.OrderInfoDeliveryLabel>
            <Styles.OrderInfoDeliveryLabel infoAlign="left">
              {Number(orderDataZustand.orderType) === 1
                ? "Atendimento na Mesa"
                : Number(orderDataZustand.orderType) === 2
                  ? "Balcão"
                  : Number(orderDataZustand.orderType) === 3
                    ? "Delivery"
                    : ""}
            </Styles.OrderInfoDeliveryLabel>
            <Styles.OrderInfoDeliveryLabel infoAlign="left">
              Tempo Decorrido:
            </Styles.OrderInfoDeliveryLabel>
            <Styles.OrderInfoDeliveryLabel infoAlign="left">
              {orderDataZustand?.createdAt ? (
                getTimeDifference(new Date(orderDataZustand.createdAt))
              ) : "Não Iniciada."}
            </Styles.OrderInfoDeliveryLabel>


            {lastOrderSelected && Number(orderDataZustand.orderStatus) <= 1 ? (
              <>
                <Styles.OrderInfoDeliveryStyledTable>
                  <thead>
                    <Styles.OrderInfoDeliveryStyledRow>
                      <th>Data do Atendimento</th>
                      <th>Total</th>
                      <Styles.TableRowRemoveButton onClick={() => handleRemoveLastOrder()}>&times;</Styles.TableRowRemoveButton>
                    </Styles.OrderInfoDeliveryStyledRow>
                  </thead>
                  <tbody>
                    <Styles.OrderInfoDeliveryStyledRow key={lastOrderSelected.orderUuid}>
                      <Styles.OrderInfoDeliveryStyledHeaderCell>{formatDateTime(lastOrderSelected.updatedAt)}</Styles.OrderInfoDeliveryStyledHeaderCell>
                      <Styles.OrderInfoDeliveryStyledHeaderCell>
                        {(() => {
                          // Antes era esta conta inteira repetida aqui dentro,
                          // com `let orderTaxs: any;` sem valor e `.reduce`
                          // sem guarda. Agora é o módulo de domínio. Card 25.
                          const products = infosDoTipo(lastOrderSelected.orderInfo, 3);
                          const productTotals = totalDosProdutos(products);
                          const orderDiscount =
                            descontoDosProdutos(products) +
                            descontoDaConta(
                              lastOrderSelected.orderInfo,
                              baseDoDesconto(products)
                            );
                          const orderTaxs = taxasDaConta(lastOrderSelected.orderInfo);
                          const orderTotal =
                            productTotals -
                            orderDiscount +
                            totalDeTaxas(orderTaxs, productTotals);

                          return orderTotal.toFixed(2).replace(".", ",");
                        })()}
                      </Styles.OrderInfoDeliveryStyledHeaderCell>
                    </Styles.OrderInfoDeliveryStyledRow>
                  </tbody>
                  <thead>
                    <Styles.OrderInfoDeliveryStyledRow>
                      <th>Produtos</th>
                    </Styles.OrderInfoDeliveryStyledRow>
                  </thead>
                  <tbody>
                    {lastOrderSelected && lastOrderSelected.orderInfo && (
                      lastOrderSelected.orderInfo
                        .filter((info: any) => info.orderInfoType === 3)
                        .map((productInfo: any) => {
                          const product = JSON.parse(productInfo.orderInfoValue);
                          return (
                            <Styles.OrderInfoDeliveryStyledRow key={product.productUuid}>
                              <Styles.OrderInfoDeliveryStyledCell onClick={() => addProductFromLastOrder(product)}>{product.productName}</Styles.OrderInfoDeliveryStyledCell>
                              {product.productObservations?.map((observation: any) => (
                                <tr key={observation.observationUuid} onClick={() => addProductObservationFromLastOrder(observation)}>
                                  <Styles.OrderInfoDeliveryStyledCell>{observation.observationName}</Styles.OrderInfoDeliveryStyledCell>
                                </tr>
                              ))}
                            </Styles.OrderInfoDeliveryStyledRow>
                          );
                        })
                    )}
                  </tbody>
                </Styles.OrderInfoDeliveryStyledTable>
              </>
            ) : Number(orderDataZustand.orderStatus) <= 1 && lastOrdersExist ? (<Styles.OrderInfoDeliveryStyledTable>
              <thead>
                <Styles.OrderInfoDeliveryStyledRow>
                  <th>Últimos Atendimentos</th>
                  <th>Total</th>
                </Styles.OrderInfoDeliveryStyledRow>
              </thead>
              <tbody>
                {currentCustomerOrders && currentCustomerOrders.map((order: any) => {
                  // Mesma conta do bloco de cima, pelo mesmo módulo. Card 25.
                  const products = infosDoTipo(order.orderInfo, 3);
                  const productTotals = totalDosProdutos(products);
                  const orderDiscount =
                    descontoDosProdutos(products) +
                    descontoDaConta(order.orderInfo, baseDoDesconto(products));
                  const orderTaxs = taxasDaConta(order.orderInfo);
                  const orderTotal =
                    productTotals -
                    orderDiscount +
                    totalDeTaxas(orderTaxs, productTotals);

                  return (
                    <Styles.OrderInfoDeliveryStyledHeaderRow key={order.orderUuid} onClick={() => handleLastOrdersRowClick(order)}>
                      <Styles.OrderInfoDeliveryStyledHeaderCell>{formatDateTime(order.updatedAt)}</Styles.OrderInfoDeliveryStyledHeaderCell>
                      <Styles.OrderInfoDeliveryStyledHeaderCell>{orderTotal.toFixed(2).replace(".", ",")}</Styles.OrderInfoDeliveryStyledHeaderCell>
                    </Styles.OrderInfoDeliveryStyledHeaderRow>
                  );
                })}
              </tbody>
            </Styles.OrderInfoDeliveryStyledTable>)
              : null}
          </>
        ) : null}
      </Styles.OrderInfoDeliveryContainer>
    );

  }
  // O `case` original não devolvia nada por aqui: em componente, é null.
  return null;
};
